export const GET_USER_TRAINING_SUCCESS = "GET_USER_TRAINING_SUCCESS";
export const GET_USER_TRAINING_FAILURE = "GET_USER_TRAINING_FAILURE";

export const USER_TRAINING_PAYMENT_SUCCESS = "USER_TRAINING_PAYMENT_SUCCESS";
export const USER_TRAINING_PAYMENT_FAILURE = "USER_TRAINING_PAYMENT_FAILURE";

export const USER_TRAINING_RECEIPT_SUCCESS = "USER_TRAINING_RECEIPT_SUCCESS";
export const USER_TRAINING_RECEIPT_FAILURE = "USER_TRAINING_RECEIPT_FAILURE";
